module.exports = __webpack_public_path__ + "img/close-warning.384d86b5.svg";